import React from "react"
import { Link } from "react-router-dom"

const AvisoLegal = () => {
    return (
        <main style={wrap}>
            <Link to="/" style={backLink}>← Volver al inicio</Link>
            <h1 style={h1}>Aviso Legal</h1>
            <p style={meta}>Última actualización: 22 de mayo de 2026</p>

            <p style={p}>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de
                la Información y de Comercio Electrónico (LSSI-CE), se ponen a disposición de los usuarios los datos
                identificativos del titular de este sitio web.</p>

            <h2 style={h2}>1. Datos identificativos del titular</h2>
            <table style={table}><tbody>
                <tr><th style={th}>Titular</th><td style={td}>ADETRES SOFTWARE, SL</td></tr>
                <tr><th style={th}>NIF</th><td style={td}>B16414161</td></tr>
                <tr><th style={th}>Domicilio social</th><td style={td}>Calle Telers 5, Pasillo B, 2ª planta, Local 3 — 08221 Terrassa (Barcelona)</td></tr>
                <tr><th style={th}>Correo electrónico</th><td style={td}><a style={aLink} href="mailto:info@ad3soft.com">info@ad3soft.com</a></td></tr>
                <tr><th style={th}>Sitio web</th><td style={td}><a style={aLink} href="https://ad3soft.com">https://ad3soft.com</a></td></tr>
            </tbody></table>

            <h2 style={h2}>2. Objeto</h2>
            <p style={p}>El presente Aviso Legal regula el acceso, navegación y uso del sitio web ad3soft.com (en adelante,
                "el Sitio Web"), titularidad de ADETRES SOFTWARE, SL (en adelante, "AD3"). El acceso al Sitio Web implica
                la aceptación sin reservas del presente Aviso Legal.</p>

            <h2 style={h2}>3. Condiciones de uso</h2>
            <p style={p}>El usuario se compromete a hacer un uso adecuado y lícito del Sitio Web y de sus contenidos, de
                conformidad con la legislación aplicable, el presente Aviso Legal, la moral, las buenas costumbres y el
                orden público. Queda prohibido el uso del Sitio Web con fines ilícitos o lesivos para AD3 o terceros, o
                que de cualquier forma puedan dañar, inutilizar o sobrecargar el Sitio Web, o impedir su normal
                utilización.</p>

            <h2 style={h2}>4. Propiedad intelectual e industrial</h2>
            <p style={p}>Todos los contenidos del Sitio Web (textos, fotografías, gráficos, imágenes, iconos, software,
                marcas, nombres comerciales, así como su diseño gráfico y código fuente) son titularidad de AD3 o de
                terceros que han autorizado su uso, y están protegidos por la normativa de propiedad intelectual e
                industrial. Queda prohibida su reproducción, distribución, comunicación pública o transformación sin
                autorización expresa de AD3.</p>

            <h2 style={h2}>5. Exclusión de responsabilidad</h2>
            <p style={p}>AD3 no se hace responsable de los daños o perjuicios que pudieran derivarse de la falta de
                disponibilidad o continuidad del Sitio Web, de errores en los contenidos, ni de la presencia de virus u
                otros elementos lesivos introducidos por terceros y ajenos al control de AD3. AD3 procura mantener la
                información actualizada y veraz, pero no garantiza la ausencia de errores ni la vigencia permanente de los
                contenidos.</p>

            <h2 style={h2}>6. Enlaces (links)</h2>
            <p style={p}>El Sitio Web puede contener enlaces a sitios de terceros. AD3 no asume responsabilidad alguna sobre
                los contenidos, políticas o prácticas de dichos sitios, cuyo acceso es responsabilidad exclusiva del
                usuario.</p>

            <h2 style={h2}>7. Protección de datos</h2>
            <p style={p}>El tratamiento de los datos personales de los usuarios se rige por la{" "}
                <Link style={aLink} to="/privacidad">Política de Privacidad</Link> y la{" "}
                <Link style={aLink} to="/cookies">Política de Cookies</Link> del Sitio Web.</p>

            <h2 style={h2}>8. Legislación aplicable y jurisdicción</h2>
            <p style={p}>El presente Aviso Legal se rige por la legislación española. Para la resolución de cualquier
                controversia que pudiera derivarse del acceso o uso del Sitio Web, las partes se someten a los Juzgados y
                Tribunales que correspondan conforme a la normativa aplicable.</p>

            <p style={footerNote}>© 2026 ADETRES SOFTWARE, SL · NIF B16414161 · Terrassa (Barcelona).</p>
        </main>
    )
}
export default AvisoLegal

const wrap: any = { maxWidth: 820, marginLeft: "auto", marginRight: "auto", padding: window.innerWidth <= 1058 ? "0 16px 60px" : "0 24px 80px", lineHeight: 1.65, color: "#1a1a2e" }
const backLink: any = { display: "inline-block", marginBottom: 18, color: "#555", textDecoration: "none", fontSize: 14 }
const h1: any = { fontSize: 30, margin: "0 0 6px" }
const meta: any = { color: "#8a8a96", fontSize: 14, marginBottom: 28 }
const h2: any = { fontSize: 20, margin: "34px 0 10px", paddingTop: 10, borderTop: "1px solid #e3e3e8" }
const p: any = { color: "#555" }
const table: any = { width: "100%", borderCollapse: "collapse", margin: "14px 0", fontSize: 15 }
const th: any = { textAlign: "left", padding: "9px 12px", border: "1px solid #e3e3e8", verticalAlign: "top", background: "#f6f7f9", color: "#1a1a2e", width: "32%" }
const td: any = { textAlign: "left", padding: "9px 12px", border: "1px solid #e3e3e8", verticalAlign: "top", color: "#555" }
const aLink: any = { color: "#2b6cb0" }
const footerNote: any = { marginTop: 44, paddingTop: 18, borderTop: "1px solid #e3e3e8", fontSize: 13, color: "#8a8a96" }
